import { RoleAssignmentDetails } from '@/features/role-assignments/components';

const RoleAssignmentDetailsPage = () => {
  return <RoleAssignmentDetails />;
};

export default RoleAssignmentDetailsPage;
